export const obtenerValorTotal = (productos) =>{

    return productos.reduce((acumulador, producto) => {
        const precio = producto.valor || 0;
        const cantidad = producto.cantidad || 1;
        return acumulador + (precio * cantidad);
    }, 0);
}